import { render, staticRenderFns } from "./ProductRankingComparison.vue?vue&type=template&id=dd06f66e&scoped=true&lang=pug&"
import script from "./ProductRankingComparison.vue?vue&type=script&lang=js&"
export * from "./ProductRankingComparison.vue?vue&type=script&lang=js&"
import style0 from "./ProductRankingComparison.vue?vue&type=style&index=0&id=dd06f66e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd06f66e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCardText,VCardTitle,VCol,VRow})
